export class PlatformLoginSubscription {
    constructor(player, gateway) {
        this.playerEvents = player;
        this.gateway = gateway;
    }
    subscribe() {
        this.playerEvents.onOneTimeTokenReceived["PlatformLoginSubscription"] = (oneTimeToken, userId) => this.gateway.oneTimeTokenLogin(oneTimeToken, userId);
        this.playerEvents.onJwtLoginReceived["PlatformLoginSubscription"] = (token) => this.gateway.jwtTokenLoginLegacy(token);
        this.playerEvents.onTwoStepLoginContinue["PlatformLoginSubscription"] = (request) => this.gateway.loginSecondStep(request);
    }
}
//# sourceMappingURL=PlatformLoginSubscription.js.map